import { mapActions, mapGetters, mapState } from 'vuex'
import {
    USER_MODULE_NAME,
    USER_SET_FLOW,
    USER_SET_FLOW_STATE,
    USER_SET_MANAGE_DAMAGE_APPOINTMENT_FLOW_RESULT,
    USER_SET_MANAGE_DAMAGE_BILLMA_FLOW_RESULT
} from '@/modules/User/store/types'
import {
    USER_FLOWS,
    USER_FLOW_STATES,
    isValidUserFlowState,
    isInsured,
    isProfessional,
    isBillmaInsured,
    isBillmaAgent,
    isBillmaAgentNew,
    isRenProfessional,
    isBillmaUser,
    isPhotoclaim,
    isE2E,
    isE2ENew
} from '@/utils/userSettings'
import { USER_SET_FLOW_HAS_IMAGES } from '../store/types'
import { isRenInsured } from '../../../utils/userSettings'
import setTimeStamp from '@/utils/timeStamp.js'
import { apiPostTimeStamp } from '@/modules/User/services/timeStamp'

/**
 * @module
 * @name UserFlowMixin
 */
export default {
    computed: {
        ...mapGetters(USER_MODULE_NAME, {
            userFlowGetter: 'userFlow',
            userFlowHasImagesGetter: 'userFlowHasImages'
        }),
        ...mapState(USER_MODULE_NAME, {
            stateUserFlowState: 'userFlowState'
        }),
        getUserFlow() {
            return this.userFlowGetter
        },
        userFlowHasImages() {
            return this.userFlowHasImagesGetter
        },
        // User types
        isInsuredUser() {
            return isInsured()
        },
        isProfessionalUser() {
            return isProfessional()
        },
        isPhotoclaimUser() {
            return isPhotoclaim()
        },
        isBillmaInsuredUser() {
            return isBillmaInsured()
        },
        isBillmaAgentUser() {
            return isBillmaAgent()
        },
        isBillmaAgentUserNew() {
            return isBillmaAgentNew()
        },
        isRenProfessionalUser() {
            return isRenProfessional()
        },
        isRenInsuredUser() {
            return isRenInsured()
        },
        isBillmaUser() {
            return isBillmaUser()
        },
        isE2EUser() {
            return isE2E()
        },
        isE2EUserNew() {
            return isE2ENew()
        },
        // User flows
        isManageDamageGAGFlow() {
            return this.getUserFlow === USER_FLOWS.MANAGE_DAMAGE_GRE_A_GRE_RESPONSE
        },
        isManageDamageContactFlow() {
            return this.getUserFlow === USER_FLOWS.MANAGE_DAMAGE_CONTACT_RESPONSE
        },
        isManageDamageAppointmentFlow() {
            return this.getUserFlow === USER_FLOWS.MANAGE_DAMAGE_APPOINTMENT_RESPONSE
        },
        isManageDamageBillmaFlow() {
            return this.getUserFlow === USER_FLOWS.MANAGE_DAMAGE_BILLMA_RESPONSE
        },
        // User flow states
        isFlowStateKo() {
            return this.stateUserFlowState === USER_FLOW_STATES.KO
        },
        isFlowStateOk() {
            return this.stateUserFlowState === USER_FLOW_STATES.OK
        },
        isFlowStateError() {
            return this.stateUserFlowState === USER_FLOW_STATES.ERROR
        }
    },
    methods: {
        ...mapActions(USER_MODULE_NAME, {
            actionUserUpdateFlow: USER_SET_FLOW,
            actionUserUpdateFlowHasImages: USER_SET_FLOW_HAS_IMAGES,
            actionUserUpdateFlowState: USER_SET_FLOW_STATE,
            actionUserUpdateManageDamageAppointmentFlowState: USER_SET_MANAGE_DAMAGE_APPOINTMENT_FLOW_RESULT,
            actionUserUpdateManageDamageBillmaFlowState: USER_SET_MANAGE_DAMAGE_BILLMA_FLOW_RESULT
        }),

        setUserFlow(userFlow) {
            return this.actionUserUpdateFlow(userFlow)
        },

        setUserFlowHasImages(userFlowHasImages) {
            return this.actionUserUpdateFlowHasImages(userFlowHasImages)
        },

        setUserFlowState(userFlowState) {
            if (isValidUserFlowState(userFlowState)) {
                return this.actionUserUpdateFlowState(userFlowState)
            } else {
                throw new TypeError(
                    `UserFlowState.error: user flow ${userFlowState} not implemented yet!`
                )
            }
        },

        setUserManageDamageAppointmentFlowResult(
            manageDamageAppointmentFlowResult
        ) {
            return this.actionUserUpdateManageDamageAppointmentFlowState(
                manageDamageAppointmentFlowResult
            )
        },

        setUserManageDamageBillmaFlowResult(manageDamageBillmaFlowResult) {
            return this.actionUserUpdateManageDamageBillmaFlowState(
                manageDamageBillmaFlowResult
            )
        },

        trackUserFlowTimeStamp(message, sinisterId) {
            const timeStamp = setTimeStamp()

            const timeStampParams = {
                description: message,
                sinister_id: sinisterId,
                start: timeStamp,
                end: timeStamp
            }

            apiPostTimeStamp(timeStampParams).catch((err) => {
                const errs = [400, 500, 409, 404]
                const errCode =
                    errs.find((errCode) => err.response.status === errCode) || 0
                this.throwNotification(
                    this.$t(`notifications.user.error.${errCode}.title`),
                    this.$t(`notifications.user.error.${errCode}.body`),
                    'KO'
                )
            })
        }
    }
}